import { DiscountType } from '../types';

import type { PromotionContextValue } from '../context/types';

// Default empty PromotionContextValue for tests of components/hooks that read from usePromotion
export const defaultPromotionContextValue: PromotionContextValue = {
  couponCode: undefined,
  referrerType: undefined,
  referrerAssociatedAt: undefined,
  coupon: undefined,
  isValid: false,
  discountAmount: 0,
  discountType: DiscountType.percentage,
  loading: false,
  error: undefined,
  isExpired: false,
  setPromotion: () => Promise.resolve(),
  clearPromotion: () => undefined,
};
